import createReducerMixin from "./createReducerMixin";
import Mappable from "lib/Mappable";

const defaultKeys = {};
const getData = props => props.dataset || {name: "", keys: defaultKeys};

const keysMissing = ({xKey, yKey}) => xKey === void 0 || yKey === void 0;

const defaultXKey = "observation time";
const defaultYKey = "# events";

function getDefaultKeys(state, nextProps, oldProps) {
    if (!keysMissing(nextProps)) {
        return {chart: null};
    }

    let nextChart = nextProps.chart || {};
    let {xKey, yKey} = nextChart;
    let prevChart = oldProps.chart || {};

    if (prevChart !== nextChart || getData(nextProps).keys !== getData(oldProps).keys) {
        if (xKey === void 0 && getData(nextProps).keys[defaultXKey]) {
            xKey = defaultXKey;
        }

        if (nextChart.type == "PieChart") {
            xKey = undefined;
            nextChart = new Mappable(nextChart)
                .filter((value, key) => key !== "stack")
                .toObject();
        }

        if (yKey === void 0 && getData(nextProps).keys[defaultYKey]) {
            yKey = defaultYKey;
        }

        state = {chart: {...nextChart, xKey, yKey}};
    }

    return state;
}

export default function defaultKeySelector(WrappedComponent) {
    return class DefaultKeySelector extends createReducerMixin(WrappedComponent, getDefaultKeys) {
        static displayName = 'DefaultKeySelector';

        render() {
            let props = this.props;

            if (keysMissing(props)) {
                props = {...props, chart: this.state.chart};
            }

            return super.render(props);
        }
    };
}



// WEBPACK FOOTER //
// ./src/kpi/common/DefaultKeySelector.js